// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://localhost:8000/api/',
  // filesUrl: 'http://localhost:8000/',
  // apiUrl: 'https://api.efit.continuousnet.com/api/',
  // filesUrl: 'https://api.efit.continuousnet.com/',
   apiUrl: 'https://api.clubfitness.tn/api/',
  filesUrl: 'https://api.clubfitness.tn/',
  filesUrl2: 'https://lihagluaehfal.ekl.tn/CLBFTNS/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
